<template>
    <div>
      <nav-breadcrumb :menu="[{label: ' 渠道商列表'}]"/>
      <div class="xzpadd10 bg-purple of">
        <data-table
          :table-data="tableData"
          :columns="columns"
          :page.sync="page"
          :pageSize.sync="pageSize"
          :filters.sync="filters"
          :actions="actions"
        />
      </div>
    </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import {xmlBuildQuery} from "../../filters/CommonActions";
  import Status2CN from "../../filters/Status2CN";
  import {removeItem} from "../../filters/CommonActions";
    export default {
        name: "DealerList",
      data(){
          return{
            columns:[
              {
                type: 'index'
              },
              {
                label: '渠道商名称',
                field: 'd__dealerName'
              },
              {
                label: '渠道商编号',
                field: 'd__dealerCode'
              },
              {
                label: '渠道商等级',
                field: 'dt__name'
              },
              // {
              //   label: '执行利率',
              //   field: 'd__interestRate',
              //   formatter: function (r,c,v) {
              //     return v+"%"+Status2CN(r.d__interestType)
              //   }
              // },
              {
                label: '负责人',
                field: 'd__personInCharge'
              },
              {
                label: '联系方式',
                field: 'd__contactNo'
              },
              {
                label: '状态',
                field: 'd__disabled',
                formatter: function (r,c,v) {
                  return Status2CN(v)
                }
              },
              {
                label: '操作',
                opts:[
                  {
                    label: '编辑',
                    class: 'el-icon-edit',
                    clickHandler: (index, row)=> {
                      this.$router.push(
                        {
                          path: 'edit',
                          query: {
                            dealerId: row.d__dealerId
                          }
                        }
                      )
                    }
                  },
                  {
                    label: '删除',
                    class: 'el-icon-delete',
                    clickHandler: (index, row)=>{
                      this.removeItem(index, row)
                    }
                  }
                ]
              }
            ],
            tableData: {
              count: 0,
              data: []
            },
            dealerTypeOptions:[],
            page: 1,
            pageSize: 20,
            actions: [
              {
                label: '新增',
                class: 'el-button--primary',
                clickHandler: ()=>{
                  this.$router.push({
                    path: 'add'
                  })
                }
              }
            ],
            filters: {
              labelWidth: '150px',
              form: {
                d__dealerName:'',
                d__dealerCode:'',
                dt__dealerTypeId:'',
              },
              columns: [

                {
                  label: '渠道商名称',
                  component: 'el-input',
                  field: 'd__dealerName'
                },
                {
                  label: '渠道商编号',
                  component: 'el-input',
                  field: 'd__dealerCode'
                },
                {
                  label: '渠道商等级',
                  component: 'el-select',
                  field: 'dt__dealerTypeId',
                  options: this.dealerTypeOptions,
                },
              ],
              onSubmit:()=>{
                this.page = 1
                this.getData()
              }
            }
          }
      },
      mounted() {
        this.getData()
        this.getDealerType()
      },
      computed: {
        filterParams() {
          return {
            pageSize: this.pageSize,
            pageOffset: (this.page - 1) * this.pageSize,
          }
        }
      },
      watch: {
        filterParams: function (newVal) {
          this.getData()
        }
      },
      methods: {
        getData: function () {
          xhr.getDealerList(
            Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
            res=> {
              try {
                this.tableData = res.data
              }catch(e){

              }
            })

        },
        getDealerType: function () {
          xhr.getDealerType(
            Object.assign({}, {}, {}),
            res=> {
              try {
                this.filters.columns[2].options = res.data.data.map(item=>{
                  return {
                    label: item.dt__name,
                    value:item.dt__dealerTypeId,
                  }
                })
              }catch(e){

              }
            })

        },
        removeItem: function (index, row) {
          removeItem(
            xhr.updateDealer,
            {
              'd.dealerId' : row.d__dealerId
            },
            res=>{
              try {
                if(res.data.status == 'success') {
                  this.getData()
                }
              }catch (e) {

              }
            }
          )
        },
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dealer/DealerList.vue